<script setup lang="ts">
import { RouterLink } from 'hybridly/vue'

const form = useForm({
	method: 'POST',
	url: route('verification.send'),
	fields: {},
})

const status = useProperty<string | null>('status')
const verificationLinkSent = computed(() => status.value === 'verification-link-sent')
</script>


					<script lang="ts">
					import __hybridly_layout_0 from '~/resources/layouts/security.vue';
					export default { layout: [__hybridly_layout_0] }
					</script>
					<template>
				
	<ui-card-content>
		<ui-alert v-if="verificationLinkSent" class="mb-4" variant="informative">
			{{ t('app.verification_link_sent') }}
		</ui-alert>

		<div class="flex flex-col items-center gap-3">
			<ui-button :loading="form.processing" class="w-fit" @click="form.submit">
				{{ t('app.buttons.resend_verification_email') }}
				<template #icon>
					<i-ph-arrow-right />
				</template>
			</ui-button>

			<ui-button
				:as="RouterLink"
				:href="route('user-profile-information.show')"
				class="w-fit"
				variant="ghost"
			>
				{{ t('app.buttons.change_email') }}

				<template #icon>
					<i-ph-arrow-right />
				</template>
			</ui-button>
		</div>
	</ui-card-content>

	<ui-card-footer :class="cn('rounded-b-none sm:rounded-b-xl', $attrs.class ?? '')">
		<div class="flex w-full items-center justify-center gap-1 text-sm text-gray-500">
			<span>{{ t('app.wrong_account') }}</span>
			<ui-link method="post" :href="route('logout')">
				{{ t('app.buttons.sign_out') }}
			</ui-link>
		</div>
	</ui-card-footer>
</template>
